import type { PaymentMethodTypeEnum } from '@bondsports/types';
import { Text } from '@components/atoms/typography';
import { Price } from '@components/molecules';
import type { ICartPayment } from '../types/interface';
import { PaymentLabel } from './components/payment-label/payment-label';

interface CartPaymentSummaryProps {
	remainingDue: number;
	payments: ICartPayment[];
	currency?: string;
	methodsLabels: Partial<Record<PaymentMethodTypeEnum, string>>;
	remainingDueLabel: string;
}

export const CartPaymentSummary = ({
	remainingDue,
	payments,
	currency,
	methodsLabels,
	remainingDueLabel,
}: CartPaymentSummaryProps) => {
	return (
		<div className="flex flex-col gap-1.5">
			<PaymentRows payments={payments} methodsLabels={methodsLabels} currency={currency} />
			<div data-testid="cart-payment-summary-total" className="flex items-center justify-between">
				<Text weight="bold">{remainingDueLabel}</Text>
				<Price weight="bold" price={remainingDue} currency={currency} />
			</div>
		</div>
	);
};

const PaymentRows = ({
	payments,
	methodsLabels,
	currency,
}: {
	payments: ICartPayment[];
	methodsLabels: Partial<Record<PaymentMethodTypeEnum, string>>;
	currency?: string;
}) => {
	return (
		<div className="flex flex-col gap-1">
			{payments.map(payment => (
				<div key={payment.id} className="flex items-center justify-between">
					<PaymentLabel paymentType={payment.paymentType} labels={methodsLabels} />
					<Price size="sm" currency={payment.currency ?? currency} price={payment.price} />
				</div>
			))}
		</div>
	);
};
